import { Link } from "react-router-dom";
import { Percent, Invoice, Lightning, ClockCounterClockwise, UsersThree, Truck, ArrowRight } from "@phosphor-icons/react";

const BENEFITS = [
  { icon: Percent, t: "Individuālas cenas", d: "Pēc B2B konta apstiprināšanas redzēsiet savas līguma cenas un individuālo atlaidi visam sortimentam." },
  { icon: Invoice, t: "Apmaksa ar rēķinu", d: "Pēcapmaksa juridiskām personām — pasūtiet uzreiz, norēķinieties pēc rēķina saņemšanas." },
  { icon: Lightning, t: "Ātrā pasūtīšana", d: "Ievadiet artikulu numurus un daudzumus sarakstā — viss grozā ar vienu klikšķi. Ideāli regulāriem pasūtījumiem." },
  { icon: ClockCounterClockwise, t: "Pasūtījumu vēsture", d: "Visi pasūtījumi un piedāvājumi vienuviet jūsu kontā — ērti atkārtot un sekot statusiem." },
  { icon: UsersThree, t: "Personīgais menedžeris", d: "B2B klientiem — savs kontaktcilvēks, kas palīdz ar produktu izvēli un piedāvājumiem lieliem apjomiem." },
  { icon: Truck, t: "Piegāde ar autoiekrāvēju", d: "Mucas un IBC konteinerus piegādājam līdz jūsu noliktavai, servisam vai saimniecībai visā Latvijā." },
];

const STEPS = [
  { n: "01", t: "Reģistrējieties", d: "Aizpildiet B2B reģistrāciju ar uzņēmuma nosaukumu, reģistrācijas un PVN numuru." },
  { n: "02", t: "Saņemiet apstiprinājumu", d: "Mūsu komanda pārbauda datus un aktivizē jūsu B2B kontu ar individuālo atlaidi 1 darba dienas laikā." },
  { n: "03", t: "Pasūtiet izdevīgāk", d: "Iepērcieties ar savām cenām, apmaksu ar rēķinu un ātro pasūtīšanu pēc artikuliem." },
];

export default function B2BPage() {
  return (
    <div>
      <section className="bg-[#0c2a44] text-white">
        <div className="mx-auto max-w-7xl px-4 py-16 md:py-20">
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-[#8FC1EA]">B2B sadarbība</p>
          <h1 className="mt-3 max-w-2xl font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
            E-veikals, kas radīts jūsu biznesam
          </h1>
          <p className="mt-4 max-w-xl text-base text-blue-100">
            Individuālas cenas, apmaksa ar rēķinu, ātrā pasūtīšana un personīgais menedžeris — viss, lai jūsu uzņēmuma iepirkumi būtu ātri un izdevīgi.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/pieteikties?b2b=1" data-testid="b2b-page-register-btn" className="btn-industrial inline-flex items-center gap-2 bg-[#2E86D1] px-7 py-3.5 text-sm font-semibold text-white hover:bg-[#1F6DB2]">
              Reģistrēt B2B kontu <ArrowRight size={18} />
            </Link>
            <Link to="/piedavajums" data-testid="b2b-page-quote-btn" className="btn-industrial border border-white/60 px-7 py-3.5 text-sm font-semibold hover:bg-white hover:text-[#0c2a44]">
              Pieprasīt piedāvājumu
            </Link>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-12 md:py-16">
        <h2 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight">Kāpēc B2B konts?</h2>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {BENEFITS.map((b) => (
            <div key={b.t} className="rounded-2xl border border-border bg-white p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50"><b.icon size={24} className="text-[#2E86D1]" /></span>
              <h3 className="mt-4 font-heading text-lg font-semibold">{b.t}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{b.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#F4F8FC] border-y border-border">
        <div className="mx-auto max-w-7xl px-4 py-12 md:py-16">
          <h2 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight">Kā tas notiek?</h2>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-5">
            {STEPS.map((s) => (
              <div key={s.n} className="rounded-2xl border border-border bg-white p-6">
                <p className="font-heading text-3xl font-bold text-[#2E86D1]">{s.n}</p>
                <h3 className="mt-3 font-heading text-lg font-semibold">{s.t}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-12 md:py-16">
        <div className="rounded-2xl bg-[#2E86D1] p-8 md:p-12 text-white flex flex-wrap items-center justify-between gap-6">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold tracking-tight">Gatavi sākt pirkt izdevīgāk?</h2>
            <p className="mt-2 text-sm text-blue-100 max-w-lg">Reģistrācija aizņem 2 minūtes. Jau šodien piekļūstiet ātrajai pasūtīšanai un apjoma cenām.</p>
          </div>
          <Link to="/pieteikties?b2b=1" data-testid="b2b-page-cta-btn" className="btn-industrial bg-white px-8 py-4 text-sm font-semibold text-[#2E86D1] hover:bg-blue-50">
            Izveidot B2B kontu
          </Link>
        </div>
      </section>
    </div>
  );
}
